import { render, staticRenderFns } from "./payment-method-issuers.vue?vue&type=template&id=b4ab9ce0&"
import script from "./payment-method-issuers.vue?vue&type=script&lang=ts&"
export * from "./payment-method-issuers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports